export default {

    COURSE_VOD_SEGMENT: {
        code: 1,
        title: '点播课小节'
    },
    AUDIO_SEGMENT: {
        code: 2,
        title: '音频小节'
    },
    DATUM: {
        code: 3,
        title: '资料'
    },
    ATLAS: {
        code: 4,
        title: '环创/图集'
    },
    ARTICLE: {
        code: 5,
        title: '资讯/文章'
    },
    SPU: {
        code: 6,
        title: '实物商品'
    },
    COURSE_VOD: {
        code: 7,
        title: '点播课'
    },

    /**
     * @param   String  title   biz type's title
     * @returns String          biz type's key
     * @author  zhiwen
     */
    getKeyByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return key;
            }
        }

        return '';
    },

    /**
     * @param   String  title   biz type's title
     * @returns String|Number   biz type's code
     * @author  zhiwen
     */
    getCodeByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return this[key].code;
            }
        }

        return '';
    }

}
